import { colors } from '@material-ui/core';

export const promoNumbers = [
  {
    color: colors.blue,
    icon: 'fas fa-graduation-cap',
    title: '1000+',
    subtitle: 'Online Courses',
    description: 'Choose from over 1000+ online video courses.',
  },
  {
    color: colors.purple,
    icon: 'fas fa-book',
    title: '800+',
    subtitle: 'Expert Instructors',
    description: 'Expert instructors to make sure courses are well.',
  },
  {
    color: colors.pink,
    icon: 'fas fa-user-graduate',
    title: '100K+',
    subtitle: 'Active Students',
    description: '100K+ active students arround the world.',
  },
  {
    color: colors.indigo,
    icon: 'fas fa-gift',
    title: '400+',
    subtitle: 'Free Resources',
    description: 'Free resources for all students arround the world.',
  },
];

export const courseCategories = [
  {
    color: colors.blue,
    icon: 'fas fa-pen-nib',
    title: 'Web Design',
    subtitle: 'Choose thousands of web design online course.',
  },
  {
    color: colors.purple,
    icon: 'fas fa-book-open',
    title: 'Business Analytics',
    subtitle: 'Choose thousands of business analytics online course.',
  },
  {
    color: colors.amber,
    icon: 'fas fa-camera-retro',
    title: 'Photography',
    subtitle: 'Choose thousands of photography online course.',
  },
  {
    color: colors.indigo,
    icon: 'fas fa-video',
    title: 'Video Creating',
    subtitle: 'Choose thousands of video creating online course.',
  },
  {
    color: colors.pink,
    icon: 'fas fa-heartbeat',
    title: 'Health & Fitness',
    subtitle: 'Choose thousands of health & fitness online course.',
  },
  {
    color: colors.green,
    icon: 'fas fa-bullhorn',
    title: 'Marketing',
    subtitle: 'Choose thousands of marketing online course.',
  },
  {
    color: colors.deepOrange,
    icon: 'fas fa-funnel-dollar',
    title: 'Finances & Sales',
    subtitle: 'Choose thousands of finaces & sales online course.',
  },
  {
    color: colors.red,
    icon: 'fas fa-paint-brush',
    title: 'Graphic Design',
    subtitle: 'Choose thousands of graphic design online course.',
  },
];

export const popularCourses = [
  {
    image: {
      src: 'https://assets.maccarianagency.com/the-front/photos/coworking/place1.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/coworking/place1@2x.jpg 2x',
    },
    title: 'UX & Web Design',
    address: 'Michael Corse',
    price: '$59 / month',
    reviews: [
      {
        authorPhoto: {
          src: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams.jpg',
          srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams@2x.jpg 2x',
        },
        authorName: 'Veronica Adams',
      },
      {
        authorPhoto: {
          src: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini.jpg',
          srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini@2x.jpg 2x',
        },
        authorName: 'Akachi Luccini',
      },
      {
        authorPhoto: {
          src: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith.jpg',
          srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith@2x.jpg 2x',
        },
        authorName: 'Jack Smith',
      },
      {
        authorPhoto: {
          src: 'https://assets.maccarianagency.com/the-front/photos/people/kate-segelson.jpg',
          srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/kate-segelson@2x.jpg 2x',
        },
        authorName: 'Kate Segelson',
      },
      {
        authorPhoto: {
          src: 'https://assets.maccarianagency.com/the-front/photos/people/alex-johnson.jpg',
          srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/alex-johnson@2x.jpg 2x',
        },
        authorName: 'Alex Johnson',
      },
      {
        authorPhoto: {
          src: 'https://assets.maccarianagency.com/the-front/photos/people/valeria-kogan.jpg',
          srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/valeria-kogan@2x.jpg 2x',
        },
        authorName: 'Valeria Kogan',
      },
    ],
    score: '5.0',
    reviewCount: 28,
  },
  {
    image: {
      src: 'https://assets.maccarianagency.com/the-front/photos/coworking/place2.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/coworking/place2@2x.jpg 2x',
    },
    title: 'Principles of Software Engineering',
    address: 'Jhon Smith',
    price: '$69 / month',
    reviews: [
      {
        authorPhoto: {
          src: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams.jpg',
          srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams@2x.jpg 2x',
        },
        authorName: 'Veronica Adams',
      },
      {
        authorPhoto: {
          src: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini.jpg',
          srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini@2x.jpg 2x',
        },
        authorName: 'Akachi Luccini',
      },
      {
        authorPhoto: {
          src: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith.jpg',
          srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith@2x.jpg 2x',
        },
        authorName: 'Jack Smith',
      },
      {
        authorPhoto: {
          src: 'https://assets.maccarianagency.com/the-front/photos/people/kate-segelson.jpg',
          srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/kate-segelson@2x.jpg 2x',
        },
        authorName: 'Kate Segelson',
      },
      {
        authorPhoto: {
          src: 'https://assets.maccarianagency.com/the-front/photos/people/alex-johnson.jpg',
          srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/alex-johnson@2x.jpg 2x',
        },
        authorName: 'Alex Johnson',
      },
      {
        authorPhoto: {
          src: 'https://assets.maccarianagency.com/the-front/photos/people/valeria-kogan.jpg',
          srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/valeria-kogan@2x.jpg 2x',
        },
        authorName: 'Valeria Kogan',
      },
    ],
    score: '4.9',
    reviewCount: 38,
  },
  {
    image: {
      src: 'https://assets.maccarianagency.com/the-front/photos/coworking/place3.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/coworking/place3@2x.jpg 2x',
    },
    title: 'Graphic Design for Beginners',
    address: 'Nicol Adams',
    price: '$49 / month',
    reviews: [
      {
        authorPhoto: {
          src: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams.jpg',
          srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams@2x.jpg 2x',
        },
        authorName: 'Veronica Adams',
      },
      {
        authorPhoto: {
          src: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini.jpg',
          srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini@2x.jpg 2x',
        },
        authorName: 'Akachi Luccini',
      },
      {
        authorPhoto: {
          src: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith.jpg',
          srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith@2x.jpg 2x',
        },
        authorName: 'Jack Smith',
      },
      {
        authorPhoto: {
          src: 'https://assets.maccarianagency.com/the-front/photos/people/kate-segelson.jpg',
          srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/kate-segelson@2x.jpg 2x',
        },
        authorName: 'Kate Segelson',
      },
      {
        authorPhoto: {
          src: 'https://assets.maccarianagency.com/the-front/photos/people/alex-johnson.jpg',
          srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/alex-johnson@2x.jpg 2x',
        },
        authorName: 'Alex Johnson',
      },
      {
        authorPhoto: {
          src: 'https://assets.maccarianagency.com/the-front/photos/people/valeria-kogan.jpg',
          srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/valeria-kogan@2x.jpg 2x',
        },
        authorName: 'Valeria Kogan',
      },
    ],
    score: '5.0',
    reviewCount: 18,
  },
  {
    image: {
      src: 'https://assets.maccarianagency.com/the-front/photos/expo-gallery/gallery1.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/expo-gallery/gallery1@2x.jpg 2x',
    },
    title: 'Marketing VS Sales',
    address: 'Joshua Karamaki',
    price: '$59 / month',
    reviews: [
      {
        authorPhoto: {
          src: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams.jpg',
          srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams@2x.jpg 2x',
        },
        authorName: 'Veronica Adams',
      },
      {
        authorPhoto: {
          src: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini.jpg',
          srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini@2x.jpg 2x',
        },
        authorName: 'Akachi Luccini',
      },
      {
        authorPhoto: {
          src: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith.jpg',
          srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith@2x.jpg 2x',
        },
        authorName: 'Jack Smith',
      },
      {
        authorPhoto: {
          src: 'https://assets.maccarianagency.com/the-front/photos/people/kate-segelson.jpg',
          srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/kate-segelson@2x.jpg 2x',
        },
        authorName: 'Kate Segelson',
      },
      {
        authorPhoto: {
          src: 'https://assets.maccarianagency.com/the-front/photos/people/alex-johnson.jpg',
          srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/alex-johnson@2x.jpg 2x',
        },
        authorName: 'Alex Johnson',
      },
      {
        authorPhoto: {
          src: 'https://assets.maccarianagency.com/the-front/photos/people/valeria-kogan.jpg',
          srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/valeria-kogan@2x.jpg 2x',
        },
        authorName: 'Valeria Kogan',
      },
    ],
    score: '4.8',
    reviewCount: 24,
  },
];

export const reviews = [
  {
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams@2x.jpg 2x',
    },
    authorName: 'Veronica Adams',
    authorOccupation: 'Growth Marketer, Crealytics',
    feedback:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini@2x.jpg 2x',
    },
    authorName: 'Akachi Luccini',
    authorOccupation: 'Lead Generation, Alternative Capital',
    feedback:
      'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
  },
  {
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith@2x.jpg 2x',
    },
    authorName: 'Jack Smith',
    authorOccupation: 'Head of Operations, Parkfield Commerce',
    feedback:
      'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
  },
];
